<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_1">Seeing Things</a></h1><a id="page_1">
</a><a id="page_2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?ead35e88